export enum RequestAccessType {
  InstitutionalRequest = 'institutional_request',
  Access = 'access',
}
